import { projectRequestCoverage, summarizeRequestPoints, type RequestCoverage } from '../../backend/shared/waf-coverage';

type Row = Record<string, unknown>;
export { summarizeRequestPoints };

export function coverageText(coverage: RequestCoverage): string {
  return coverage.status === 'complete' ? Number(coverage.observedTotal).toLocaleString()
    : coverage.status === 'partial' ? `${Number(coverage.observedTotal).toLocaleString()}（取得分・部分集計）` : '不明';
}

/** An incomplete ACL inventory or a failed ACL must never become a complete tenant total. */
export function summarizeDashboardRequests(metrics: Row[], expectedAclCount: number, inventoryComplete: boolean, field: string): RequestCoverage {
  const windows = new Set(metrics.map(row => `${row.startTime}/${row.endTime}/${row.period}`));
  const same24HourWindow = windows.size === 1 && metrics.every(row => Date.parse(String(row.endTime)) - Date.parse(String(row.startTime)) === 24 * 3600_000 && row.period === 60);
  const coverage = metrics.map(row => projectRequestCoverage(row.requestCoverage, row.truncated === true)[field]);
  const hasObserved = coverage.some(item => item?.observedTotal !== null);
  const complete = inventoryComplete && metrics.length === expectedAclCount && same24HourWindow && metrics.every((row, index) => row.truncated !== true && coverage[index]?.status === 'complete');
  const observedMinutes = same24HourWindow ? coverage.reduce((sum, item) => sum + (item?.observedMinutes ?? 0), 0) : 0;
  const expectedMinutes = expectedAclCount * 1440;
  return { status: complete ? 'complete' : hasObserved && same24HourWindow ? 'partial' : 'unknown', expectedMinutes, observedMinutes,
    missingMinutes: Math.max(0, expectedMinutes - observedMinutes), observedTotal: hasObserved && same24HourWindow ? coverage.reduce((sum, item) => sum + (item?.observedTotal ?? 0), 0) : null };
}
